import Vue from 'vue'
import VueRouter from 'vue-router'
import PaginaInicio from '@/views/PaginaInicio.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: PaginaInicio,
  },
  {
    path: '/catalogo',
    name: 'Catálogo',
    component: () => import('@/views/PaginaCatalogo.vue'),
  },
  {
    path: '/radiombligo',
    name: 'Cápsulas',
    component: () => import('@/views/PaginaCapsulas.vue'),
  },
  {
    path: '/acceso-abierto',
    name: 'Acceso Abierto',
    component: () => import('@/views/PaginaAccesoAbierto.vue'),
  },
  {
    path: '/acerca-de',
    name: 'Acerca de',
    component: () => import('@/views/PaginaAcercaDe.vue'),
  },
  {
    path: '**',
    name: 'pagina-no-encontrada',
    component: () => import('@/views/ErrorPaginaNoEncontrada.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          x: 0,
          y: 80,
        },
      }
    } else {
      return { x: 0, y: 0, behavior: 'smooth' }
    }
  },
})

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} | ${to.name}`
  next()
})

export default router
